var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.985 15.408 3.242 3.686c1.2 1.365 1.8 2.048 2.43 1.881.628-.166.844-1.064 1.275-2.86l2.39-9.969c.665-2.768.997-4.15.259-4.834s-2.017-.175-4.575.84L5.14 8.865c-2.046.813-3.07 1.22-3.134 1.917a1 1 0 0 0 0 .214c.063.7 1.084 1.108 3.128 1.927.925.371 1.388.557 1.72.912q.056.06.108.124c.306.38.436.88.697 1.876l.489 1.867c.253.97.38 1.456.713 1.522s.622-.336 1.2-1.14zm0 0-.317-.33c-.362-.378-.543-.566-.543-.8s.18-.423.543-.8l3.573-3.724"
  })));
};
export default SvgTelegram;